import { AuthState } from './../../models/authentication.model';
import * as fromModels from '../../models/authentication.model';
import * as fromAction from '../actions/authentication.actions';
import { convertAfUser, isEmailVerifiedOrProvider } from '../../helpers/auth.helpers';
import { StoreAction } from '../../models/rootState.model';
import { environment } from 'src/environments/environment';
import { LoggedUser, Permission } from 'src/app/models/Users';
import { EntityHelper } from 'src/app/features/entity/helpers/entity-helper';
import { stat } from 'fs';

const AUTH_INITIAL_STATE: fromModels.AuthState = {
  afUser: null,
  user: null,
  isLogged: false,
  loading: '',
  loaded: false,
  error: null,
  gcm_loaded: false
};

export function AuthReducer(state = AUTH_INITIAL_STATE, action: StoreAction): AuthState {

  switch (action.type) {

    case fromAction.AUTH_ACTION_TYPES.SET_ADMIN_ACCESS: {

      const user = state.user;
      const role: Permission = {
        permissions: { owner: true },
        target_id: +action.payload.id,
        user_id: +user.id,
        created_at: new Date().toISOString() as any
      };

      user.roles.push(role);
      const entityInstance = EntityHelper.getInstance(action.payload);
      const target: any[] = user.permissions[entityInstance.source_name] || [];
      target.push(entityInstance);

      return {
        ...state,
        user
      };
    }

    case fromAction.AUTH_ACTION_TYPES.AUTH_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: ''
      };
    }

    case fromAction.AUTH_ACTION_TYPES.GCM_LOADED: {
      return {
        ...state,
        gcm_loaded: true
      };
    }

    case fromAction.AUTH_ACTION_TYPES.USER_DATA_SET: {
      const _data = Object.assign(state.user, action.payload);

      return {
        ...state,
        user: new LoggedUser(_data)
      };
    }

    case fromAction.AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER:
    case fromAction.AUTH_ACTION_TYPES.SIGNIN:
    case fromAction.AUTH_ACTION_TYPES.SIGNIN_WITH_FACEBOOK:
    case fromAction.AUTH_ACTION_TYPES.SIGNIN_WITH_GOOGLE: {
      return {
        ...state,
        loading: 'Iniciando autenticação...'
      };
    }

    case fromAction.AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER_SUCCESS:
    case fromAction.AUTH_ACTION_TYPES.SIGNIN_WITH_FACEBOOK_SUCCESS:
    case fromAction.AUTH_ACTION_TYPES.SIGNIN_WITH_GOOGLE_SUCCESS:
    case fromAction.AUTH_ACTION_TYPES.SIGNIN_FIREBASE_SUCCESS: {

      // #TODO - Ajustar aqui para quando for melhorar o offline
      // para OFFLINE, é necessário manter o loaded como true aqui
      const st = {
        ...state,
        loaded: !!(state.user && action.payload)
      };
      if (action.type == fromAction.AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER_SUCCESS) {
        st.loading = null;
      }

      st.afUser = convertAfUser(action.payload);

      // if the user email is verified, mark as logged in
      st.isLogged = !!(st.user && st.afUser && isEmailVerifiedOrProvider(st.afUser));

      return st;
    }

    case fromAction.AUTH_ACTION_TYPES.IMAGE_PROFILE_CHANGED: {
      const newState = { ...state };
      newState.user.photo_url = action.payload;
      return newState;
    }

    case fromAction.AUTH_ACTION_TYPES.RETRIEVE_LOGGED_USER_DATA:
    case fromAction.AUTH_ACTION_TYPES.USER_DATA_UPDATED_BY_STARTUP: {
      return {
        ...state,
        loading: 'carregando suas preferencias...'
      };
    }

    case fromAction.AUTH_ACTION_TYPES.USER_DATA_RELOADED:
    case fromAction.AUTH_ACTION_TYPES.RETRIEVE_LOGGED_USER_DATA_SUCCESS: {

      const st = {
        ...state,
        loaded: !!(state.afUser && action.payload),
        user: action.payload,
        loading: null,
        isLogged: !!(!!action.payload && !!state.afUser && isEmailVerifiedOrProvider(state.afUser))
      };

      if (!st.isLogged) {
        if (localStorage.getItem('fu_local') && environment.environment == 'local') {
          st.isLogged = st.user && st.user.id.toString() == localStorage.getItem('fu_local');
        }
      }

      return st;
    }

    case fromAction.AUTH_ACTION_TYPES.LOAD_CURRENT_FIREBASE_USER_EMPTY: {
      return {
        ...state,
        loading: null,
        loaded: true,
        isLogged: false,
        afUser: null,
        user: null
      };
    }

    case fromAction.AUTH_ACTION_TYPES.SIGNOUT_SUCCESS: {
      return {
        ...state,
        loading: '',
        isLogged: false,
        error: null,
        afUser: null,
        user: null
      };
    }

    case fromAction.AUTH_ACTION_TYPES.SIGNUP: {
      return {
        ...state,
        loading: 'Criando conta...',
      };
    }

    case fromAction.AUTH_ACTION_TYPES.SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: null,
      };
    }

    case fromAction.AUTH_ACTION_TYPES.SIGNOUT: {
      return {
        ...state,
        loading: 'Saindo do sistema...'
      };
    }

    case fromAction.AUTH_ACTION_TYPES.IS_LOADING: {
      return {
        ...state,
        loading: action.payload || true
      };
    }

    case fromAction.AUTH_ACTION_TYPES.IS_NOT_LOADING: {
      return {
        ...state,
        loading: null
      };
    }

    case fromAction.AUTH_ACTION_TYPES.USER_DATA_UPDATED_BY_FORM:
    case fromAction.AUTH_ACTION_TYPES.RELOAD: {
      return {
        ...state,
        loading: 'Atualizando dados do usuário...'
      };
    }

    default: {
      return state;
    }
  }

}
